export const defaultMessageCancelButton = 'Não'
export const defaultMessageConfirmButton = 'Sim'
